import { Application, $Router } from 'app/classes';
import { SETTINGS } from 'app/settings';

export interface IIdentityApplication {
    created_at: string;
    description: string;
    id: string;
    in_maintenance_mode: boolean;
    is_archived: boolean;
    is_service: boolean;
    language_list: Array<any>;
    language_version: string;
    launchpad_display: boolean;
    logo: string;
    maintenance_url: string;
    name: string;
    namespace: string;
    publisher_org_id: string;
    publisher_user_id: string;
    roles: Array<any>;
    slug: string;
    slug_archive: string;
    status: string;
    updated_at: string;
    url: string;
    version: string;
}

export class ApplicationService {

    /**
     * filter and sort apps for provided user based on roles and preferred apps
     * @param apps {Array} array of applications to filter and sort
     * @param roles {Array} roles of specific user
     * @returns {Array} array of applications that user has permission to see,
     *          sorted with preferred apps first
     */
    public static getAuthorizedApps(apps, roles): Array<Application> {

        // required for local development
        for (const app of apps) {
            if (app.namespace === 'cphome') {
                // ensure that url matches launchpad configuration
                app.url = $Router.apps.get('launchpad').url;
                break;
            }
        }

        ApplicationService.addCpHomeUserRole(roles);
        apps = ApplicationService.preferredAppSort(apps);

        return apps.map((appdata) => {
            const app = new Application(appdata);
            app.privileged = true;
            app.passToken = true;
            return app;
        });
    }

    /**
     * sort apps by (1) preferred apps, then (2) alphabetically
     * @param apps {Array} apps to be sorted
     * @returns {Array} sorted application objects
     */
    private static preferredAppSort(apps: Array<IIdentityApplication>) {

        const prefApps = [];
        for (const pref of SETTINGS.PREFERRED_APPS) {
            for (let i = 0; i < apps.length; i++) {
                if (apps[i].namespace === pref) {
                    prefApps.push(apps[i]);
                    apps.splice(i, 1);
                    break;
                }
            }
        }
        apps.sort((a: IIdentityApplication, b: IIdentityApplication) => {
            // alphabetically sort apps based on application.name
            // returning -1 put app a in from of app b, 0 does nothing,
            // 1 put app b in front of app a
            const aName = a.name.toLowerCase();
            const bName = b.name.toLowerCase();
            return aName === bName ? 0 : Number(aName > bName) || -1;
        });
        return [].concat(prefApps).concat(apps);
    }

    /**
     * add the cphome:user role
     * @param roles {Array} array of roles in string format. IE 'foo_app:admin'
     */
    private static addCpHomeUserRole(roles: Array<string>): void {
        // band-aid to add cphome namespace to every user
        if (roles.indexOf('cphome:user') === -1) {
            roles.push('cphome:user');
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/services/application.service/application.service.ts